import type { CampaignVariantTargetsQueryVariables } from '~/api/graphql/queries/campaignVariantTargets.generated';
import type { CampaignStatus, CampaignType } from '~/types/graphql';

import { CAMPAIGN_STATUS, CAMPAIGN_TYPE } from '~/constants/campaign';

/** A finished experiment gives its pages back, so only these three can still be holding one. */
export const PICK_PAGE_USAGE_CAMPAIGN_STATUS: CampaignStatus[] = [
  CAMPAIGN_STATUS.DRAFT,
  CAMPAIGN_STATUS.RUNNING,
  CAMPAIGN_STATUS.PAUSED,
];

/**
 * Campaign types that can already be holding a page this modal offers. Deliberately not paired with
 * a `templateType`: `campaignVariantTargets` ANDs its arguments, and a URL test's variants carry no
 * template type at all, so narrowing to `PRODUCT` templates would drop every URL experiment.
 */
export const PICK_PAGE_USAGE_CAMPAIGN_TYPE: CampaignType[] = [
  CAMPAIGN_TYPE.PRICE,
  CAMPAIGN_TYPE.TEMPLATE,
  CAMPAIGN_TYPE.TEMPLATE_BUNDLE,
  CAMPAIGN_TYPE.URL,
];

/**
 * One set of variables for every reader of `campaignVariantTargets`, so the modal's list and a URL
 * typed into a field are answered by the same cache entry rather than two fetches of the same list.
 */
export const PICK_PAGE_USAGE_QUERY_VARIABLES: CampaignVariantTargetsQueryVariables = {
  status: PICK_PAGE_USAGE_CAMPAIGN_STATUS,
  campaignType: PICK_PAGE_USAGE_CAMPAIGN_TYPE,
};
